import { render, staticRenderFns } from "./ManageGlobalDomainAllowlist.vue?vue&type=template&id=7746b8ec&scoped=true"
import script from "./ManageGlobalDomainAllowlist.vue?vue&type=script&lang=ts"
export * from "./ManageGlobalDomainAllowlist.vue?vue&type=script&lang=ts"
import style0 from "./ManageGlobalDomainAllowlist.vue?vue&type=style&index=0&id=7746b8ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7746b8ec",
  null
  
)

export default component.exports